import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import Loading from '../../components/Loading';

import accountRouter from '../account';

const FactoryDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "factory-floor-dashboard" */ '../../pages/factory-floor-dashboard'
    ),
);

const factoryFloorDashboardRouter = (
  <Route path="factory-floor-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <FactoryDashboardComponent />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default factoryFloorDashboardRouter;
